module.exports = __webpack_public_path__ + "static/media/cross-icon.b89e4caa.svg";